import Vue from "vue";
import { Component } from "vue-property-decorator";
import moment from "moment";
import { EventBus } from "../Controls/EventBus";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ParametresInstance } from "../Controls/Parameters";
import { ExerciceDto } from "../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import ModalOuvertureExercice from "./modalOuvertureExercice/modalOuvertureExercice";
import ModalModifExercice from "./modalModifExercice/modalModifExercice";
import ModalOuverturePremierExercice from "../modalComponents/modalOuverturePremierExercice/modalOuverturePremierExercice";

import * as $ from "jquery";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { SocieteAdministratifDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteAdministratifDto";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Component({
    beforeRouteEnter(to, from, next) {
        next(v => {
            const vm = (v as ExercicesComponent);
            vm.Init();
        });
    },
    components: {
        ModalOuvertureExercice: require("./modalOuvertureExercice/modalOuvertureExercice.vue.html"),
        ModalModifExercice: require("./modalModifExercice/modalModifExercice.vue.html"),
        ModalOuverturePremierExercice: require("../modalComponents/modalOuverturePremierExercice/modalOuverturePremierExercice.vue.html")
    }
})
export default class ExercicesComponent extends Vue {
    public dataReady = false;
    public paieEnable = false;
    public exercices: ExerciceDto[] = [];
    public exercicesFiltred: ExerciceDto[] = [];

    public currentOrderColumn = "NumeroValidation";
    public orderingDesc = false;

    public exerciceSelect: number[] = [];
    public filterExercice = 0;
    public SocieteAdministratif?: SocieteAdministratifDto = undefined;

    public nombreJoursConges?: number = undefined;

    public Init(): void {
        this.refreshListeExercices();
    }

    public mounted(): void {
        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
            this.nombreJoursConges = ParametresInstance.societeCourante != undefined ? ParametresInstance.societeCourante.JourneesAcquis : undefined;
        });
        this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
        this.nombreJoursConges = ParametresInstance.societeCourante != undefined ? ParametresInstance.societeCourante.JourneesAcquis : undefined;
        if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
            ServicesFactoryInstance.SocieteService.getSocieteAdministratif(ParametresInstance.societeCourante.Code, (data) => {
                this.SocieteAdministratif = data;
            });
        }
    }

    public modify(): void {
        if (this.SocieteAdministratif) {
            this.SocieteAdministratif.JournesAcquis = this.nombreJoursConges;
            ServicesFactoryInstance.SocieteService.updateSocieteAdministratif(this.SocieteAdministratif, (codeSociete) => {
                NotificationServiceInstance.SendSuccess("La société a bien été modifiée.");

                ServicesFactoryInstance.SocieteService.getSocieteAdministratif(codeSociete, data => {
                    this.SocieteAdministratif = data;
                    if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
                        ParametresInstance.societeCourante.JourneesAcquis = this.SocieteAdministratif.JournesAcquis;
                    }
                });
            });
        }
    }

    public getClassOfOrder(columnName: string, desc: any): string {
        if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
            return "active";
        }

        return "icons";
    }

    public orderBy(columnName: string): void {
        if (this.currentOrderColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }
        this.currentOrderColumn = columnName;
        this.doOrder();
    }

    public doOrder(): void {
        if (this.exercicesFiltred != undefined) {
            this.exercicesFiltred.sort(this.sortFunction);
        }
    }

    public sortFunction(a: any, b: any): number {
        if (a[this.currentOrderColumn] < b[this.currentOrderColumn]) {
            return (this.orderingDesc ? -1 : 1);
        }
        if (a[this.currentOrderColumn] > b[this.currentOrderColumn]) {
            return (this.orderingDesc ? 1 : -1);
        }

        return 0;
    }

    public doFilter(): void {
        if (this.exercices == undefined) {
            return;
        }

        this.exercicesFiltred = this.exercices.filter(e => e.Annee == this.filterExercice);
        this.doOrder();
    }

    public setDates(): void {
        if (this.exercices == undefined) {
            return;
        }

        for (let i = 0; i < this.exercices.length; i++) {
            const annee = this.exercices[i].Annee;
            if (this.exerciceSelect.filter(e => e == annee).length == 0) {
                this.exerciceSelect.push(annee);
            }
        }

        this.exerciceSelect = this.exerciceSelect.sort((a, b) => b - a);
        this.filterExercice = this.exerciceSelect[0];
    }

    public getUTCMonth(id: number): string {
        return moment.utc().month(id - 1).format("MMMM")[0].toUpperCase() + moment.utc().month(id - 1).format("MMMM").slice(1);
    }

    public modalOuvertureExercice?: ModalOuvertureExercice = undefined;

    public message(): void {
        if (this.modalOuvertureExercice == undefined) {
            this.modalOuvertureExercice = this.$refs.modalOuvertureExercice as ModalOuvertureExercice;
        }

        this.modalOuvertureExercice.Init();
        $("#modalOuvertureExercice").modal("show");
    }

    public modalModifExercice?: ModalModifExercice = undefined;

    public consulterMessage(): void {
        if (this.modalModifExercice == undefined) {
            this.modalModifExercice = this.$refs.modalModifExercice as ModalModifExercice;
        }

        this.modalModifExercice.Init();
        $("#modalModifExercice").modal("show");
    }

    public ouvrirExercice(): void {
        const modal = this.$refs.modalOuverturePremierExercice as ModalOuverturePremierExercice;
        const exerciceOuvert = this.exercices?.some(e => e.NumeroValidation === 99999);

        // Société sans exercice existant
        if (this.exercices.length === 0) {
            modal?.init();
        }
        else if (!this.exercices || !exerciceOuvert) {
            const dernierExercice = this.getLastExercices();
            modal?.init(dernierExercice);
        } else {
            NotificationServiceInstance.SendFailed("Il existe déjà un exercice ouvert pour cette société.");
        }
    }

    public downloadConges(idExercice: any): void {
        ServicesFactoryInstance.AbsencesService.GetAbsencesExcel(idExercice, data => {
            this.download(data);
            this.$forceUpdate();
        });
    }

    public supprimerExercice(exercice: ExerciceDto): void {
        this.dataReady = false;
        ServicesFactoryInstance.ExercicesService.supprimerExercice(exercice.Id, () => {
            NotificationServiceInstance.SendSuccess("L'exercice a bien été supprimé.");

            this.clearExerciceCourant();
            this.refreshListeExercices();
        }, () => {
            this.dataReady = true;
            NotificationServiceInstance.SendFailed("Une erreur est survenue, l'exercice n'a pas été supprimé.");
        });
    }


    public download(r: Blob): void {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(r, "absences.xlsx");
            this.dataReady = true;
        } else {
            this.dataReady = true;

            const link = document.createElement("a");
            document.body.appendChild(link);

            link.href = window.URL.createObjectURL(r);
            link.download = "absences.xlsx";
            link.click();
        }
    }

    public refreshListeExercices(): void {
        if (ParametresInstance.societeCourante == undefined) {
            return;
        }
        this.dataReady = false;

        ServicesFactoryInstance.ExercicesService.getExercices(data => {
            this.exercices = data;
            this.exercicesFiltred = data;
            this.setDates();
            this.doFilter();
            this.getClassOfOrder(this.currentOrderColumn, true);
            this.dataReady = true;
        }, () => {
            this.dataReady = true;
            NotificationServiceInstance.SendFailed("Une erreur est survenue, la récupération des exercices a échoué");
        });
    }

    private clearExerciceCourant(): void {
        if (ParametresInstance.societeCourante !== undefined) {
            ParametresInstance.societeCourante.PeriodeActive = undefined;
            ParametresInstance.societeCourante.AnneeExerciceEnCours = undefined;
            ParametresInstance.societeCourante.MoisExerciceEnCours = undefined;
        }
    }

    private getLastExercices(): ExerciceDto {
        return this.exercices.reduce((max, current) => {
            if (
                current.Annee > max.Annee ||
                (current.Annee === max.Annee && current.Mois > max.Mois)
            ) {
                return current;
            }
            return max;
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/exercices/exercices.ts